import { AttachmentData } from '../../common';
import { DocumentStatusEnum } from '../enums';

// Intentionally has "Bit" prefix to avoid any mistakes with HTML's "Document"
export interface BitDocument {
  id: string;
  profileId: string;
  typeId: number;
  userId: string;
  number: string;
  status: DocumentStatusEnum;
  createdAt: string;
  updatedAt: string;
  attachments: AttachmentData[];
}

export enum EGovIdType {
  Unknown = "Unknown",
  Passport = "Passport",
  Visa = "Visa",
  DriverLicense = "Drivers License",
  IdCard = "Identification Card",
  Permit = "Permit",
  Currency = "Currency",
  ResidenceDoc = "Residence Document",
  TravelDoc = "Travel Document",
  BirthCert = "Birth Certificate",
  VehicleReg = "Vehicle Registration",
  Other = "Other",
  WeaponLicense = "Weapon License",
  TribalId = "Tribal Identification",
  VoterId = "Voter Identification",
  Military = "Military",
  TaxId = "Tax Identification",
  FederalId = "Federal ID",
  MedicalCard = "Medical Card",
}

export enum EFycCheckStatus {
  Ok = "OK",
  Fail = "FAIL",
  Unknown = "UNKNOWN",
}

export interface FycDocument {
  userId: string,
  govIdType: EGovIdType,
  sessionId: string,
  govIdName: string,
  govIdDescription: string,
  totalScoreStatus: EFycCheckStatus,
  livenessScoreStatus: EFycCheckStatus,
  faceRecognitionScoreStatus: EFycCheckStatus,
  incodeIdValidationScoreStatus: EFycCheckStatus,
  idOcrValidationScoreStatus: EFycCheckStatus,
  governmentScoreStatus: EFycCheckStatus,
  expireAt: string
}